const reviewFrequencies = [
  { id: "-1", name: "Please select review frequency" },
  { id: "1", name: "6 month" },
  { id: "2", name: "Yearly" },
  { id: "3", name: "Biennial" },
  { id: "4", name: "Other" },
];

export default reviewFrequencies;
